<script setup lang="ts">
import { CalendarCheck01Icon } from '@gohighlevel/ghl-icons/24/outline'
import {
  UIModal,
  UIModalFooter,
  UIModalHeader,
  UISelect,
} from '@gohighlevel/ghl-ui'

import Team from '@/models/team'
import AppState from '@/states/app'
import { computed, ref, watch } from 'vue'
const props = defineProps({
  show: Boolean,
})

const emit = defineEmits(['onConfirm', 'onModalClose', 'update:show'])

const handleSave = () => {
  emit('onConfirm', selectedTeam.value)
}
const handleCancel = () => {
  emit('onModalClose')
}

const teams = computed(() => {
  return AppState.globalTeams?.teams || []
})

const teamOptions = computed(() => {
  return teams.value.map((team: Team) => ({
    label: team.name,
    value: team.id,
  }))
})

watch(
  () => teamOptions.value,
  () => {
    if (teamOptions.value.length > 0) {
      selectedTeam.value = teamOptions.value[0].value
    }
  }
)

const selectedTeam = ref('')
</script>

<template>
  <UIModal
    id="generalConfirmationModal"
    :width="700"
    :show="show"
    @update:show="val => $emit('update:show', val)"
  >
    <template #header>
      <UIModalHeader
        id="generalConfirmationModalHeader"
        type="primary"
        :title="$t('settings.calendar.select_calendar_group')"
        :icon="CalendarCheck01Icon"
        @close="handleCancel"
      />
    </template>

    <UISelect
      id=""
      v-model:value="selectedTeam"
      :placeholder="$t('placeholders.select_one')"
      :options="teamOptions"
    />

    <template #footer>
      <UIModalFooter
        id="generalConfirmationModalFooter"
        :negative-text="$t('settings.calendar.cancel')"
        :positive-text="$t('settings.calendar.select')"
        @negative-click="handleCancel"
        @positive-click="handleSave"
      />
    </template>
  </UIModal>
</template>
